
export const IntroAnimation = (function () {
	'use strict';

    let intro, animation;
	function init() {
        intro = $('.intro');
        if(intro.length !== 1){ return };

		events();
	}

	function events() {
        console.log(sessionStorage);
        if(sessionStorage.getItem("intro") !== 'completed') {
            animation = bodymovin.loadAnimation({
                container: document.getElementById('intro-animation'), // Required
                path: document.getElementById('intro-animation').dataset.animation, // Required
                renderer: 'svg/canvas/html', // Required
                loop: false, // Optional
                autoplay: true, // Optional
                name: "Break Your Bias Introduction",
                prerender: false,
                autoloadSegments: false,
            }) 
            animation.addEventListener('complete', function(){
                intro.removeClass('intro--active');
                sessionStorage.setItem('intro', 'completed');
            });
        } else {
            intro.removeClass('intro--active');
        }
    }

	return {
		init: init,
	};
})();
